import { breakpoint } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/AlternativeTransportLeftPanel";
import { ISirkPanel } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/ISirkPanel";
import { SkiftplanPanel } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/SkiftplanPanel";
import { SimpleStickyController } from "features/CenterContent/VehicleDetails/shared/SimpleStickyController";
import { Box } from "shared/components/Spor";
import { AlternativeTransportVehicle } from "shared/types/alternativeTransport";
import { hideOnWidthClassname } from "shared/utils/hideOnWidth";
import { useTheme } from "styled-components";

interface AlternativeTransportRightPanelProps {
  vehicle: AlternativeTransportVehicle;
}

export const AlternativeTransportRightPanelScroll = ({
  vehicle,
}: AlternativeTransportRightPanelProps) => {
  const theme = useTheme();

  const hideOnSmall = (
    <>
      <Box
        className={hideOnWidthClassname("hide-on-small", breakpoint)}
        overflowY="auto"
      >
        <SimpleStickyController
          stickyBackground={theme.colorBackgroundMain}
          headerHeight="54px"
          gap="6px"
        >
          <SkiftplanPanel vehicle={vehicle} />
        </SimpleStickyController>
      </Box>
      <Box
        className={hideOnWidthClassname("hide-on-small", breakpoint)}
        overflowY="auto"
      >
        <SimpleStickyController
          stickyBackground={theme.colorBackgroundMain}
          headerHeight="54px"
          gap="6px"
        >
          <ISirkPanel vehicle={vehicle} />
        </SimpleStickyController>
      </Box>
    </>
  );

  const hideOnLarge = (
    <Box
      className={hideOnWidthClassname("hide-on-large", breakpoint)}
      overflowY="auto"
    >
      <SimpleStickyController
        stickyBackground={theme.colorBackgroundMain}
        headerHeight="54px"
        gap="6px"
      >
        <SkiftplanPanel vehicle={vehicle} />
        <ISirkPanel vehicle={vehicle} />
      </SimpleStickyController>
    </Box>
  );

  return (
    <>
      {hideOnSmall}
      {hideOnLarge}
    </>
  );
};
